import tw from 'twin.macro'
import styled from 'styled-components'

export const ModalTitleWrapper = styled.div`
  ${tw`font-secondary font-bold`}
  font-size: 24px;
  line-height: 30px;
  margin: 0;
  padding: 0 0 40px;
  color: #ffffff;

  a {
    ${tw`font-primary font-light text-sm underline flex flex-row items-center gap-1 mt-2`}
  }
`
